import { useContext } from 'react';
import { ApplicationView } from './ApplicationView';
import { StudentView } from './StudentView';
import { Breadcrumb } from './Breadcrumb';
import { BreadCrumbContext, defaultBreadCrumbStatus } from './index';
import { useAppCategoryResult } from '../utils/useAppCategoryResult';
import { HistoryView } from './HistoryView';

type Props = {
    category: App.AppsCategory,
    onSearch: ReturnType<typeof useAppCategoryResult>[1],
};

export const ResultView: React.FC<Props> = ({
    category,
    onSearch,
}) => {
    const { breadcrumb, setBreadcrumb } = useContext(BreadCrumbContext);
    const handleClickAllBreadCrumb = () => {
        setBreadcrumb(defaultBreadCrumbStatus);
    };

    const handleClickPreviousBreadcrumb = (history: AppStatusModal.Breadcrumb) => {
        setBreadcrumb(history);
    };

    return (
        <>
            <Breadcrumb
                title={breadcrumb.name ?? ''}
                onClick={handleClickAllBreadCrumb}
                history={breadcrumb?.history}
                onClickPreviousBreadcrumb={handleClickPreviousBreadcrumb}
            />
            {breadcrumb.type === 'Student' &&
                <StudentView />
            }
            {breadcrumb.type === 'Application' &&
                <ApplicationView
                    category={category}
                    onSearch={onSearch}
                />
            }
            {breadcrumb.type === 'History' &&
                <HistoryView
                    category={category}
                />
            }
        </>
    );
}